import {
  BEGIN_LOADING,
  CLEAR_LOADING,
  GET_CAROUSELS,
  GET_MEMBER_ACTIONS,
  GET_MEMBER_ACTION_IS_READ,
  UPDATE_MEMBER_ACTION_IS_READ,
  GET_ORDERS,
} from "../actions/types";

const initialState = {
  carousels: [],
  actionLogs: [],
  isRead: 0,
  orders: [],
  loading: false
};

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_CAROUSELS:
      return {
        ...state,
        carousels: action.payload,
        loading: false
      };
    case GET_MEMBER_ACTIONS:
      return {
        ...state,
        actionLogs: action.payload,
        loading: false
      };
    case GET_MEMBER_ACTION_IS_READ:
      return {
        ...state,
        isRead: action.payload.cnt,
        loading: false
      };
    case UPDATE_MEMBER_ACTION_IS_READ:
      return {
        ...state,
        isRead: 0,
        loading: false
      };
    case GET_ORDERS:
      return {
        ...state,
        orders: action.payload,
        loading: false
      };
    case BEGIN_LOADING:
      return {
        ...state,
        loading: true
      };
    case CLEAR_LOADING:
      return {
        ...state,
        loading: false
      };

    default:
      return state;
  }
}
